const state = () => ({
  socials: [],
})

const mutations = {
  setSocials (state, socials) {
    state.socials = socials
  },
}

const actions = {
  fetchSocials ({ state, commit }) {
    commit('setLoading', true, { root: true })

    return this.$axios
      .$get('auth/socials')
      .then((response) => {
        commit('setSocials', response.items)
        return response.items
      })
      .finally(() => {
        commit('setLoading', false, { root: true })
      })
  },
  fetchVKAuthorizationUrl () {
    return this.$axios.$get('auth/socials/vk/auth/url')
  },
  fetchYandexAuthorizationUrl () {
    return this.$axios.$get('auth/socials/yandex/auth/url')
  },
  loginByVK  ({ dispatch, commit, rootGetters }, { code, vkDeviceId }) {
    const promise = this.$axios.$post('auth/socials/vk/login', { code, vkDeviceId })

    return dispatch('auth/handleLogin', promise, { root: true })
  },
  loginByYandex ({ dispatch, commit, rootGetters }, { code }) {
    const promise = this.$axios.$post('auth/socials/yandex/login', { code })

    return dispatch('auth/handleLogin', promise, { root: true })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
